import React from 'react'

import './style.css'

const text = (props, classes) => {
  return <p className={`Text ${classes} ${props.show === false ? 'Hide' : ''}`}>{props.children}</p>
}
const T = ({ ...props }) => text(props)
const ErrorText = ({ ...props }) => text(props, 'Error')

export default T
export {
  ErrorText,
}



// WEBPACK FOOTER //
// ./src/components/Text/index.js